import Vue from 'vue'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import VueSimpleMarkdown from 'vue-simple-markdown'
import VueScrollTo from 'vue-scrollto'
import deMessages from 'devextreme/localization/messages/de.json'
import { locale as devExtremeLocale, loadMessages } from 'devextreme/localization'
import VueIntro from 'vue-introjs'
import VueMask from 'v-mask'
import { setInteractionMode } from 'vee-validate'
import numeral from 'numeral'

import App from '@/App.vue'
import router from '@/router/index.js'
import store from '@/store/index.js'
import i18n from './i18n.js'

import 'devextreme/dist/css/dx.common.css'
import 'devextreme/dist/css/dx.light.css'
import '@/assets/scss/main.scss'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/de'
import ElementUI from 'element-ui'
import '../vee-validate.js'

import DefaultLayout from '@/layouts/DefaultLayout.vue'
import LoginLayout from '@/layouts/LoginLayout.vue'
import EmptypageLayout from '@/layouts/EmptyPageLayout.vue'

devExtremeLocale(navigator.language)
loadMessages(deMessages)

numeral.register('locale', 'de-ch', {
  delimiters: {
    thousands: "'",
    decimal: '.'
  }
})
numeral.locale('de-ch')

Vue.filter('formatCurrency', (value) => {
  return numeral(Number(value)).format('0,0.00')
})

Vue.filter('formatNumber', (value) => {
  return numeral(Number(value)).format('0,0')
})

Vue.component('default-layout', DefaultLayout)
Vue.component('login-layout', LoginLayout)
Vue.component('empty-page-layout', EmptypageLayout)

setInteractionMode('eager')
Vue.use(require('vue-moment'))
Vue.use(ElementUI, { locale })
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VueSimpleMarkdown)
Vue.use(VueScrollTo)
Vue.use(VueIntro)
Vue.use(VueMask)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
